<script setup lang="ts">
  import {
    computed,
    nextTick,
    onActivated,
    onBeforeUnmount,
    onMounted,
    reactive,
    ref,
    watch,
  } from 'vue';
  import {
    actions as actionTypes,
    useUserComponent,
    useHelpers,
    createComponentScope,
    Resource,
    uniqueID,
  } from '@integro/core';
  import type { IAppHelpers } from '@integro/core';
  import * as _ from 'lodash';

  defineOptions({
    name: 'UcPropertyValidityCard',
  });

  const componentMetadata = {
    kind: 'usercontrol',
  };

  const emit = defineEmits(['reload', 'close', 'save']);

  const props = defineProps({
    item: {
      type: Object,
      required: true,
    },
  });

  const {
    $app,
    $fn,
    $i18n,
    $store,
    $config,
    $imodal,
    $notification,
    $tabs,
    $route,
    $router,
    gettext,
    pgettext,
    ngettext,
    npgettext,
    schemaDefaults,
    getSchema,
    searchDataSource,
    randomElementId,
    datetime,
    date,
    time,
    number,
    money,
    distance,
    username,
    filesize,
  } = useHelpers();

  const ux = ref([]);

  const $data = computed(() => ({
    ux: ux.value,
  }));

  const {
    loading,
    error,
    loaded,
    reloading,
    showLoadingIndicator,
    loadDataThrottled,
    friendlyName,
    loadData,
    touchLastLoaded,
    handleError,
    setData,
    forms,
    registerForm,
    unregisterForm,
    canLoadData,
    isModalComponent,
    modalName,
    pageDocument: _pageDocument,
    routeTab,
    ux: _ux,
    componentMetadata: _componentMetadata,
    $uid,
    lastLoaded,
  } = useUserComponent(props, {
    metadata: componentMetadata,
    dataSpecs: [{ name: 'ux' }],
    loaders: {},
    ux: {},
    dataRefs: { ux },
  });

  const $component = createComponentScope(
    {
      $app,
      $fn,
      $i18n,
      $store,
      $imodal,
      $notification,
      $tabs,
      $router,
    } as IAppHelpers,
    {
      emit,
      forms,
      error,
      isModalComponent,
      modalName,
      componentMetadata,
      loadData,
      registerForm,
      unregisterForm,
      setData,
      touchLastLoaded,
      handleError,
    }
  );

  watch(
    () => props.item,
    (newValue, oldValue) => {
      if (_.isEqual(newValue, oldValue)) return;
      loadDataThrottled('item');
    }
  );

  const act_7315092382398562_reloadComponentData_mwskm5v7m =
    new actionTypes.ReloadComponentDataAction({});
  const inst_evh_7315092382398562_reload_8rnsabrm9 =
    new actionTypes.EventHandlerImpl({
      action: act_7315092382398562_reloadComponentData_mwskm5v7m,
      event: 'reload',
      displayName: 'reloadComponentData',
    });
  const inst_evh_7315092382398562_reload = new actionTypes.EventHandlerGroup({
    handlers: [inst_evh_7315092382398562_reload_8rnsabrm9],
    event: 'reload',
  });

  const actions = {
    inst_evh_7315092382398562_reload_8rnsabrm9,
    inst_evh_7315092382398562_reload,
  };

  const evh_7315092382398562_reload_8rnsabrm9 = async (event, scope) => {
    return await actions.inst_evh_7315092382398562_reload_8rnsabrm9.executeFromDOM(
      $component,
      event,
      scope
    );
  };
  const evh_7315092382398562_reload = async (event, scope) => {
    return await actions.inst_evh_7315092382398562_reload.executeFromDOM(
      $component,
      event,
      scope
    );
  };

  defineExpose({
    loadData,
    loading,
    loaded,
    error,
  });
</script>

<template>
  <ItpUsercontrol
    :loading="loading"
    :reloading="reloading"
    :loaded="loaded"
    :error="error"
    @reload="evh_7315092382398562_reload($event, {})"
  >
    <div v-if="!item.valid_from">
      <ItpText muted>{{ pgettext('Property', 'From') }}:</ItpText>
      {{ pgettext('Property', 'N/A') }}
    </div>
    <div v-if="item.valid_from">
      <ItpText muted>{{ pgettext('Property', 'From') }}:</ItpText>
      {{ item.valid_from }}
    </div>
    <div v-if="item.valid_to">
      <ItpText muted>{{ pgettext('Property', 'To') }}:</ItpText>
      {{ item.valid_to }}
    </div>
    <div v-if="!item.valid_to">
      <ItpText muted>{{ pgettext('Property', 'To') }}:</ItpText>
      {{ pgettext('Property', 'Indefinite') }}
    </div>
  </ItpUsercontrol>
</template>
